import React from "react";
import { Partners } from "./Datas/Partners";

const CompanyExample = () => {
    return (
        <>
            {" "}
            <section className=" bg-gray-50">
                <div className="container mx-auto max-w-6xl px-5 py-section-sm xl:px-0">
                    <h1 className="text-h2 font-semibold text-gray-800 dark:text-white">
                        기업사례
                    </h1>
                    <div className="mt-8 grid grid-cols-2 gap-3 sm:gap-5 md:grid-cols-3 xl:grid-cols-4">
                        {Partners.map(post => (
                            <div
                                key={post.name}
                                className="flex h-32 flex-col items-center justify-center rounded-lg bg-white px-4 py-4 sm:h-48 sm:px-6"
                            >
                                <img
                                    className="h-12 w-full rounded-lg object-contain sm:h-20"
                                    src={post.imageSrc}
                                    alt=""
                                />
                                <h2 className="mt-2 text-caption font-semibold capitalize text-gray-800 dark:text-white sm:mt-4 sm:text-xl">
                                    {post.name}
                                </h2>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default CompanyExample;
